(function () {
  function addZero(x) {
    return x < 10 && x >= 0 ? '0' + x : x;
  }

  function initCopyButtons(root) {
    root.querySelectorAll('[data-fd-copy]').forEach(function (button) {
      if (button.dataset.fdBound) return;
      button.dataset.fdBound = 'true';
      button.addEventListener('click', function () {
        var text = button.getAttribute('data-fd-copy');
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(text).then(function () {
          button.classList.add('is-copied');
          setTimeout(function () {
            button.classList.remove('is-copied');
          }, 1800);
        });
      });
    });
  }

  function initCountdowns(root) {
    root.querySelectorAll('[data-fd-countdown]').forEach(function (el) {
      if (el.dataset.fdBound) return;
      el.dataset.fdBound = 'true';

      var year = parseInt(el.dataset.year, 10);
      var month = parseInt(el.dataset.month, 10);
      var day = parseInt(el.dataset.day, 10);
      var hour = parseInt(el.dataset.hour, 10) || 0;
      var minute = parseInt(el.dataset.minute, 10) || 0;
      var timezone = el.dataset.timezone;

      if (!year || !month || !day) return;

      var dateString = month + '/' + day + '/' + year + ' ' + hour + ':' + minute + ' GMT' + timezone;
      var countDownDate = new Date(dateString).getTime();

      var daysEl = el.querySelector('[data-fd-days]');
      var hoursEl = el.querySelector('[data-fd-hours]');
      var minutesEl = el.querySelector('[data-fd-minutes]');
      var secondsEl = el.querySelector('[data-fd-seconds]');
      var card = el.closest('.fd-coupon-card');

      function update() {
        var distance = countDownDate - Date.now();

        if (distance < 0) {
          daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
          el.classList.add('is-expired');
          if (card) card.classList.add('is-expired');
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = addZero(days);
        hoursEl.textContent = addZero(hours);
        minutesEl.textContent = addZero(minutes);
        secondsEl.textContent = addZero(seconds);

        requestAnimationFrame(update);
      }
      requestAnimationFrame(update);
    });
  }

  function init() {
    initCopyButtons(document);
    initCountdowns(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
